import 'css-chunksrc/client/scenes/notifications/notification/mentionInComment/styles.scss';export default {
  "notification": "_notification_clfjs_1",
  "header": "_header_clfjs_8",
  "date": "_date_clfjs_18",
  "main": "_main_clfjs_24",
  "author": "_author_clfjs_28",
  "avatar": "_avatar_clfjs_38",
  "authorName": "_authorName_clfjs_43",
  "text": "_text_clfjs_49",
  "content": "_content_clfjs_56",
  "mention": "_mention_clfjs_63",
  "seeMore": "_seeMore_clfjs_67"
};